import { render, staticRenderFns } from "./PoliticasPrivacidad.vue?vue&type=template&id=c42e69ca&scoped=true&"
import script from "./PoliticasPrivacidad.vue?vue&type=script&lang=js&"
export * from "./PoliticasPrivacidad.vue?vue&type=script&lang=js&"
import style0 from "./PoliticasPrivacidad.vue?vue&type=style&index=0&id=c42e69ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42e69ca",
  null
  
)

export default component.exports